import React from "react";
import queryString from "query-string";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import Button from "designV2/components/Button";
import logo from "assets/img/sparkLoginLogo.svg";
import "./standalonePage.css";

/**
 * The deep links that take a customer back out of the browser.
 *
 * Only the schemes the apps are known to register are listed. Anything
 * missing gets the plain "close this window" message rather than a
 * button that silently does nothing — a payment page is the worst
 * place to guess.
 */
const APP_LINKS = {
  success: {
    order: "spark://payment/order/success",
    trip: "spark://payment/trip/success",
    tripPay: "spark://lastPayment/success",
  },
  fail: {
    order: "spark://payment/order/fail",
    trip: "spark://payment/trip/fail",
  },
};

/**
 * PaymentResult - where a payment redirect lands.
 *
 * Reached from the card form, and from the Stripe Connect return in
 * BankInfo, so it has to make sense without knowing what was being
 * paid for. `?for=order|trip|tripPay` is added by the card form and
 * turns the message into a way back into the app.
 *
 * @param {Object} props
 * @param {"success"|"fail"} props.outcome - Which result to show
 */
const PaymentResult = ({ outcome, location }) => {
  const succeeded = outcome === "success";
  const paymentFor = queryString.parse((location && location.search) || "").for;
  const appLink = APP_LINKS[outcome][paymentFor];

  return (
    <div className="standalonePage">
      <div className="standaloneInner isNarrow">
        <div className="standaloneBrand">
          <img src={logo} alt="Spark" />
        </div>

        <div className="standaloneCard">
          <div className="standaloneResult">
            <span className={`standaloneResultIcon ${succeeded ? "success" : "danger"}`}>
              {succeeded ? <CheckCircleIcon /> : <CancelIcon />}
            </span>

            <h1 className="standaloneResultTitle">
              {succeeded ? "All done" : "That did not go through"}
            </h1>

            <p className="standaloneResultText">
              {succeeded
                ? "Your payment went through. There is nothing else to do here."
                : "Your payment was not completed and you have not been charged. Try again from the app."}
            </p>

            {appLink ? (
              <Button
                variant="primary"
                size="lg"
                onClick={() => {
                  window.location = appLink;
                }}
              >
                Back to the app
              </Button>
            ) : (
              <p className="standaloneResultText">
                You can close this window and return to the Spark app.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentResult;
